import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  root: {
    height: '100%',
    minWidth: '100%',
    maxWidth: '100%',
  },
  imageContainer: {
    position: 'relative',
    width: '100%',
    aspectRatio: '16 / 9',
    '& > a': {
      display: 'block',
      height: '100%',
    },
  },
  imageWrapper: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  thumbnailImage: {
    objectFit: 'cover',
  },
  infoContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  mainPadding: {
    padding: theme.spacing(4),
  },
  greyBackground: {
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.12)' // Subtle light overlay in dark mode
        : theme.palette.custom.grey.light, // Light grey in light mode
  },
  contentLabelContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    lineHeight: 0,
  },
  postMetaContainer: {
    paddingBottom: theme.spacing(2),
    width: '100%',
    minWidth: 0,
    lineHeight: 1,
  },
  categoryRowContainer: {
    display: 'flex',
    alignItems: 'center',
    lineHeight: 1,
    '& a': {
      lineHeight: 1,
    },
  },
  categoryLink: {
    color: theme.palette.brands?.elevator_red ?? theme.palette.secondary.main,
  },
  authorLink: {
    color: theme.palette.text.secondary,
  },
  titleLink: {
    color:
      theme.palette.mode === 'dark'
        ? theme.palette.text.primary
        : theme.palette.primary.main,
    '&:hover': {
      color: theme.palette.brands?.elevator_red ?? theme.palette.secondary.main,
      textDecoration: 'none',
    },
  },
  // Horizontal variant: image left, 124px height
  smallContainer: {
    minHeight: 0,
  },
  smallCard: {
    display: 'flex',
    height: 124,
    overflow: 'hidden',
  },
  smallImageContainer: {
    width: 124,
    height: 124,
    flexShrink: 0,
    position: 'relative',
    '& > a': {
      display: 'block',
      height: '100%',
      width: '100%',
    },
  },
  smallInfoPadding: {
    padding: theme.spacing(2),
    flex: 1,
    minWidth: 0,
    gap: theme.typography.pxToRem(14),
  },
  smallPostMetaContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.typography.pxToRem(4),
    paddingBottom: 0,
  },
  smallTitleLink: {
    color:
      theme.palette.mode === 'dark'
        ? theme.palette.text.primary
        : theme.palette.primary.main,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    '&:hover': {
      color: theme.palette.brands?.elevator_red ?? theme.palette.secondary.main,
      textDecoration: 'none',
    },
  },
  // Featured variant: card and image fill parent (for use in FeaturedPostGrid)
  featuredContainer: {
    height: '100%',
    minHeight: 0,
  },
  featuredCard: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  featuredImageContainer: {
    flex: 1,
    minHeight: 0,
    position: 'relative',
    '& > a': {
      display: 'block',
      height: '100%',
      width: '100%',
    },
  },
}));
